<!-- 
A table showing a matrix of roles and permissions.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog lg">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Role permissions matrix</v-toolbar-title>
          <v-spacer/>
          <our-user-guide-button topic="administration-roles-and-permissions"/>
        </v-toolbar>
        <our-busy-indicator :show="busy"/>
        <v-card-text>
          <div style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th class="column text-xs-left">Permission</th>
                  <th v-for="role in roles.data" :key="'th-' + role.id" class="column text-xs-center">{{ role.name }}</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="category in categories"
                >
                  <tr :key="`category-${category}`">
                    <td :colspan="roleCount + 1">
                      <b>
                        {{ lookups.permissionCategoryDescriptions[category] }}
                      </b>
                    </td>
                  </tr>
                  <tr v-for="permission in getPermissions(category)" :key="'tr-' + permission">
                    <td>{{ lookups.permissionClaimTypeDescriptions[permission] }}</td>
                    <td v-for="role in roles.data" :key="'td-' + role.id + '-' + permission" class="text-xs-center">
                      <v-icon v-if="isTicked(role.permissions, permission)" color="success">check_circle</v-icon>
                      <v-icon v-else color="grey">not_interested</v-icon>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="busy" :loading="processing" flat @click="exportToExcel">Export to Excel</v-btn>
          <v-btn :disabled="busy" flat @click="hide">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from "underscore";
import lookupMixins from "@/mixins/lookup.mixins";
import { EXPORT } from "@/store/roles/action-types";

export default {
  mixins: [lookupMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showValidationDialog: false
    };
  },
  computed: {
    roles() {
      return this.$store.state.roles.listing;
    },
    roleCount() {
      return this.roles.data.length;
    },
    loaded() {
      return this.roles.loaded;
    },
    busy() {
      return this.roles.loading;
    },
    categories() {
      return _(this.lookups.permissionCategories).pluck("value");
    },
    processing() {
      return this.$store.state.roles.exportToExcel.processing;
    }
  },
  methods: {
    getPermissions(category) {
      const permissions = _(this.lookups.permissionClaimTypes).filter(
        p => p.attributeData.permissionCategory.category == category
      );
      return _(permissions).pluck("value");
    },
    hide() {
      this.$emit("update:show", false);
    },
    isTicked(rolePermissions, permission) {
      return _.contains(rolePermissions, permission);
    },
    exportToExcel() {
      this.$store.dispatch(EXPORT);
    }
  }
};
</script>
